import { render, staticRenderFns } from "./AboutCover.vue?vue&type=template&id=40a7a36b&scoped=true&"
import script from "./AboutCover.vue?vue&type=script&lang=js&"
export * from "./AboutCover.vue?vue&type=script&lang=js&"
import style0 from "./AboutCover.vue?vue&type=style&index=0&id=40a7a36b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7a36b",
  null
  
)

export default component.exports